import type {
  TherapistAppointment,
  AppointmentStatus,
} from '../../../../types/therapist-dashboard.types';

export type ViewMode = 'day' | 'week' | 'month';

export type { TherapistAppointment, AppointmentStatus };

// Status styling configuration
export const statusStyles: Record<
  AppointmentStatus,
  { bg: string; text: string; darkBg: string; darkText: string; border: string; label: string }
> = {
  confirmed: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    darkBg: 'dark:bg-blue-900/30',
    darkText: 'dark:text-blue-300',
    border: 'border-blue-300 dark:border-blue-700',
    label: 'Confirmed',
  },
  completed: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    darkBg: 'dark:bg-green-900/30',
    darkText: 'dark:text-green-300',
    border: 'border-green-300 dark:border-green-700',
    label: 'Completed',
  },
  cancelled: {
    bg: 'bg-red-100',
    text: 'text-red-700',
    darkBg: 'dark:bg-red-900/30',
    darkText: 'dark:text-red-300',
    border: 'border-red-300 dark:border-red-700',
    label: 'Cancelled',
  },
  no_show: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    darkBg: 'dark:bg-yellow-900/30',
    darkText: 'dark:text-yellow-300',
    border: 'border-yellow-300 dark:border-yellow-700',
    label: 'No Show',
  },
  pending: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    darkBg: 'dark:bg-gray-800',
    darkText: 'dark:text-gray-300',
    border: 'border-gray-300 dark:border-gray-600',
    label: 'Pending',
  },
};
